import React, { useEffect, useState } from "react";
import { useAPI } from "../lib/common";

const useTemplate = (uuid, version) => {
  let url = "/api/webshop/templates/by-uuid/" + uuid;
  if (version) {
    url += "/" + version;
  }
  return useAPI(url);
};

export default useTemplate;
